import type { AutomationView } from '@adweb/shared';
import { LayoutGrid, List } from 'lucide-react';

import { TILE_COLUMN_OPTIONS, useUiPreferences } from '../preferences/ui-preferences';

/**
 * Bascule Liste / Tuiles. Le choix est enregistré comme préférence personnelle,
 * donc retrouvé sur l'accueil et lors des prochaines connexions.
 */
export function ViewToggle({ inHeader = false }: { inHeader?: boolean }) {
  const { automationView, tileColumns, update } = useUiPreferences();
  const options: Array<{ value: AutomationView; label: string; icon: typeof List }> = [
    { value: 'LIST', label: 'Liste', icon: List },
    { value: 'TILES', label: 'Tuiles', icon: LayoutGrid },
  ];
  return (
    <div
      className="flex flex-wrap items-center gap-1"
      role="group"
      aria-label="Présentation des automatisations"
    >
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          aria-pressed={automationView === o.value}
          onClick={() => automationView !== o.value && update.mutate({ automationView: o.value })}
          disabled={update.isPending}
          className={
            inHeader
              ? 'hdr-ctl inline-flex items-center gap-1.5'
              : `inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-medium transition ${
                  automationView === o.value
                    ? 'border-brand bg-brand text-white'
                    : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50'
                }`
          }
        >
          <o.icon className="h-3.5 w-3.5" aria-hidden="true" />
          {o.label}
        </button>
      ))}
      {automationView === 'TILES' && (
        <div
          className="ml-2 flex items-center gap-1"
          role="group"
          aria-label="Nombre de tuiles par ligne"
        >
          <span className={inHeader ? 'page-header-sub text-xs' : 'text-xs text-slate-500'}>
            Par ligne
          </span>
          {TILE_COLUMN_OPTIONS.map((n) => (
            <button
              key={n}
              type="button"
              aria-pressed={tileColumns === n}
              aria-label={`${n} tuiles par ligne`}
              onClick={() => tileColumns !== n && update.mutate({ tileColumns: n })}
              disabled={update.isPending}
              className={
                inHeader
                  ? 'hdr-ctl min-w-[2rem] px-2'
                  : `min-w-[2rem] rounded-lg border px-2 py-1.5 text-xs font-semibold transition ${
                      tileColumns === n
                        ? 'border-brand bg-brand text-white'
                        : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50'
                    }`
              }
            >
              {n}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
